export default __webpack_public_path__ + "static/media/Plus.b06fffe7.svg";